// Default Consent Mode state, injected beforeInteractive. When the store is
// embedded in the Overwolf app iframe the client already has the user's
// consent, so we default to 'granted'; everywhere else we stay 'denied' until
// the cookie bar updates it. The caller decides which, based on
// useIsOverwolfIframe.
export const consentScript = (granted: boolean): string => {
  const state = granted ? 'granted' : 'denied';
  return `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent','default',{ ad_storage:'${state}', analytics_storage:'${state}',
  ad_user_data:'${state}', ad_personalization:'${state}', wait_for_update:500 });`;
};
